import { FC } from 'react';

import { Box } from '@mui/material';
import { useGetDimensionalityOptions } from 'constants/businessTool';

import { CurrencyLabelComponent } from 'components/_basic/Currency/CurrencyLabelComponent';
import { GLOBAL_UNIT_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { ICurrencyUnitSelectorProps } from './types';
import { BaseSelector } from '../BaseSelector/BaseSelector';

export const CurrencyUnitSelector: FC<ICurrencyUnitSelectorProps> = ({
  disabled = false,
  showCurrency = true,
  containerProps,
}) => {
  const DIMENSIONALITY_OPTIONS = useGetDimensionalityOptions();
  return (
    <Box>
      <BaseSelector
        name={GLOBAL_UNIT_NAME}
        disabled={disabled}
        options={DIMENSIONALITY_OPTIONS}
        defaultValue={DIMENSIONALITY_OPTIONS[0].value}
        label={showCurrency ? <CurrencyLabelComponent disabled={disabled} /> : null}
        containerProps={containerProps}
      />
    </Box>
  );
};
